import { render, staticRenderFns } from "./Postcurado.vue?vue&type=template&id=037f4a73&"
import script from "./Postcurado.vue?vue&type=script&lang=js&"
export * from "./Postcurado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports